
<main class="flex-1 overflow-auto bg-gray-50 p-2 sm:p-4">
    <button
        type="button"
        (click)="goBack()"
        class="flex items-center gap-2 mb-4 cursor-pointer text-gray-700 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200"
        >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
        Back
</button>
    <div class=" w-full bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden p-4 sm:p-6 mx-auto mb-4">
        <h2 class="text-2xl font-semibold text-gray-900 mb-6">User - Property Details</h2>
        <!-- Tabs Header -->
        <div class="border-b border-gray-200">
            <nav class="flex gap-6 sm:gap-10 overflow-x-auto scrollbar-hide whitespace-nowrap pb-2">
                <button *ngFor="let tab of tabs" (click)="setActiveTab(tab)" class="relative py-3 sm:py-4 text-sm sm:text-lg font-medium cursor-pointer transition-colors duration-200 shrink-0" [ngClass]="
                        activeTab === tab
                        ? 'text-blue-600'
                        : 'text-gray-500 hover:text-gray-700'
                    ">
                    {{ tab }}
                    <!-- Active underline -->
                    <span *ngIf="activeTab === tab" class="absolute left-0 -bottom-[1px] w-full h-[3px] bg-blue-600 rounded-full">
                    </span>
                </button>
            </nav>
        </div>

        <!-- Tabs Content -->
        <div class="mt-8">

            <div *ngIf="activeTab === 'User Profile' && isRoteHasPermissions('canManageUsers')" class=" text-gray-700">
                <div class="bg-white rounded-2xl sm:rounded-3xl border border-gray-200 shadow-sm p-4 sm:p-6">

                    <!-- Header -->
                    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

                        <div>
                            <h2 class="text-xl font-semibold text-gray-900">
                                User Information
                            </h2>
                            <p class="text-sm text-gray-500 mt-1">
                                View profile details, advisor info and approval actions
                            </p>
                        </div>

                        <span
                            class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border w-fit"
                            [class]="_US.getStatusClass(userDetails?.state)">
                            {{ userDetails?.state || 'Pending' }}
                        </span>

                    </div>


                    <!-- Main Grid -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 items-start gap-4 sm:gap-5">

                        <!-- Name -->
                        <div class="rounded-2xl border border-gray-200 p-4">
                            <p class="text-xs uppercase tracking-wide text-gray-500">Name</p>
                            <h4 class="mt-2 text-base font-semibold text-gray-900">
                                {{ userDetails?.name }}
                            </h4>
                        </div>

                        <!-- Email -->
                        <div class="rounded-2xl border border-gray-200 p-4">
                            <p class="text-xs uppercase tracking-wide text-gray-500">Email</p>
                            <h4 class="mt-2 text-base font-semibold text-gray-900 break-all">
                                {{ userDetails?.email }}
                            </h4>
                        </div>

                        <!-- Mobile -->
                        <div class="rounded-2xl border border-gray-200 p-4">
                            <p class="text-xs uppercase tracking-wide text-gray-500">Mobile</p>
                            <h4 class="mt-2 text-base font-semibold text-gray-900">
                                {{ userDetails?.country?.dial }} {{ userDetails?.phone }}
                            </h4>
                        </div>

                        <!-- User Type -->
                        <div class="rounded-2xl border border-gray-200 p-4">
                            <p class="text-xs uppercase tracking-wide text-gray-500">User Type</p>
                            <h4 class="mt-2 text-base font-semibold text-gray-900">
                                {{ userDetails?.userType ?? 'Basic' }}
                            </h4>
                        </div>

                        <!-- Advisor -->
                        <div class="rounded-2xl border border-gray-200 p-4">
                            <p class="text-xs uppercase tracking-wide text-gray-500">
                                Assigned Advisor
                            </p>

                            <div class="mt-2">

                                <h4 class="text-base font-semibold text-gray-900">
                                    {{ userDetails?.assignedAdvisor?.name ?? 'Not Assigned Advisor' }}
                                </h4>

                                <p
                                    *ngIf="userDetails?.assignedAdvisor?.email"
                                    class="text-sm text-gray-500 mt-1">
                                    {{ userDetails?.assignedAdvisor?.email }}
                                </p>

                                <p
                                    *ngIf="userDetails?.assignedAdvisor?.phone"
                                    class="text-sm text-gray-500">
                                    {{ userDetails?.country?.dial ?? '+91' }}
                                    {{ userDetails?.assignedAdvisor?.phone }}
                                </p>

                            </div>
                        </div>

                        <!-- Approval / Rejection Reason -->
                        <div
                            *ngIf="userDetails?.state !== 'Pending'"
                            class="rounded-2xl p-5 border"
                            [ngClass]="userDetails?.state === 'Approved'
                                ? 'bg-green-50 border-green-200'
                                : 'bg-orange-50 border-orange-200'">

                            <h3
                                class="text-sm font-semibold"
                                [ngClass]="userDetails?.state === 'Approved'
                                    ? 'text-green-700'
                                    : 'text-orange-700'">

                                {{ userDetails?.state === 'Approved'
                                    ? 'Approval Reason'
                                    : 'Rejection Reason' }}

                            </h3>

                            <p class="text-sm text-gray-700 mt-2 leading-6">
                                {{ userDetails?.statusReason || 'No message available.' }}
                            </p>

                        </div>

                        <div class="rounded-2xl border border-gray-200 p-4"
     [class.animate-shake]="userDetails && !userDetails.otpVerified"
     [class.animate-fade-in-up]="userDetails?.otpVerified">

  <p class="text-xs uppercase tracking-wide text-gray-500">
    User OTP verification
  </p>

  <div class="mt-2 flex items-center gap-2.5">

    <!-- Verified icon -->
    <div *ngIf="userDetails?.otpVerified" class="relative w-8 h-8 flex-shrink-0">
      <span class="absolute inset-0 rounded-full border-2 border-green-500 animate-ping opacity-75"></span>
      <svg viewBox="0 0 32 32" class="w-8 h-8">
        <circle cx="16" cy="16" r="15" fill="#EAF3DE"/>
        <polyline points="9,16 13.5,21 23,11"
          stroke="#3B6D11" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round"
          fill="none"
          class="animate-check-draw"/>
      </svg>
    </div>

    <!-- Not verified icon -->
    <div *ngIf="userDetails && !userDetails.otpVerified" class="w-8 h-8 flex-shrink-0">
      <svg viewBox="0 0 32 32" class="w-8 h-8">
        <circle cx="16" cy="16" r="15" fill="#FCEBEB"/>
        <line x1="11" y1="11" x2="21" y2="21"
          stroke="#A32D2D" stroke-width="2.2" stroke-linecap="round"
          class="animate-x-draw"/>
        <line x1="21" y1="11" x2="11" y2="21"
          stroke="#A32D2D" stroke-width="2.2" stroke-linecap="round"
          class="animate-x-draw-delayed"/>
      </svg>
    </div>

    <h4 class="text-base font-semibold"
        [class.text-green-800]="userDetails?.otpVerified"
        [class.text-red-800]="userDetails && !userDetails.otpVerified">
      {{ userDetails?.otpVerified ? 'Verified' : 'Not Verified' }}
    </h4>
  </div>
</div>

                    </div>


                    


                    <!-- Actions -->
                    <div class="mt-6 pt-6 border-t border-gray-200">

                        <p class="text-xs uppercase tracking-wide text-gray-500 mb-3">
                            Actions
                        </p>

                        <div class="flex flex-col sm:flex-row flex-wrap gap-3">

                            <button
                                (click)="assignAdvisor('')"
                                class="w-full sm:w-auto px-4 py-2.5 rounded-xl border border-blue-500 text-blue-700 font-medium hover:bg-blue-500 hover:text-white transition">
                                Change Advisor
                            </button>

                            <span *ngIf="isRoteHasPermissions('canEditSettings')" class="flex flex-col sm:flex-row flex-wrap gap-3">

                                <button
                                    *ngIf="!userDetails?.isApproved || !userDetails?.isGetPremimum "
                                    (click)="openApprovalModal(userDetails._id,'Approved')"
                                    class="w-full sm:w-auto px-4 py-2.5 rounded-xl border border-green-500 text-green-700 font-medium hover:bg-green-500 hover:text-white transition">
                                    Approve
                                </button>

                                <button
                                    *ngIf="!userDetails?.isApproved || !userDetails?.isGetPremimum"
                                    (click)="openApprovalModal(userDetails._id,'Rejected')"
                                    class="w-full sm:w-auto px-4 py-2.5 rounded-xl border border-orange-500 text-orange-700 font-medium hover:bg-orange-500 hover:text-white transition">
                                    Reject
                                </button>

                                <button
                                    *ngIf="userDetails?.isApproved || userDetails?.isGetPremimum"
                                    (click)="openDeleteConfirm(userDetails._id)"
                                    class="w-full sm:w-auto px-4 py-2.5 rounded-xl border border-red-500 text-red-700 font-medium hover:bg-red-500 hover:text-white transition">
                                    Remove
                                </button>

                            </span>

                        </div>

                    </div>

                </div>
                <div *ngIf="userDetails?.subsctions" class="rounded-2xl overflow-hidden border border-gray-100 shadow-sm mt-10">

                    <!-- Header -->
                    <div class="px-5 py-3 flex items-center justify-between"
                        [ngClass]="userDetails.subsctions.membershipType === 'Premium'
                            ? 'bg-gradient-to-r from-indigo-600 to-violet-600'
                            : 'bg-gray-100'">
                        <div class="flex items-center gap-2">
                            <svg *ngIf="userDetails.subsctions.membershipType === 'Premium'" class="w-4 h-4 text-yellow-300" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                            </svg>
                            <span class="text-sm font-black"
                                [ngClass]="userDetails.subsctions.membershipType === 'Premium' ? 'text-white' : 'text-gray-700'">
                                {{ userDetails.subsctions.membershipType }} Plan
                            </span>
                        </div>
                
                        <!-- Status pill -->
                        <span class="px-2.5 py-0.5 rounded-full text-[10px] font-black uppercase tracking-wider"
                            [ngClass]="userDetails.subsctions.subscriptionStatus === 'active'
                                ? 'bg-green-400/20 text-green-200 ring-1 ring-green-300/30'
                                : 'bg-red-400/20 text-red-200 ring-1 ring-red-300/30'">
                            <span class="inline-block w-1.5 h-1.5 rounded-full mr-1 align-middle"
                                [ngClass]="userDetails.subsctions.subscriptionStatus === 'active' ? 'bg-green-300 animate-pulse' : 'bg-red-300'">
                            </span>
                            {{ userDetails.subsctions.subscriptionStatus }}
                        </span>
                    </div>
                
                    <!-- Body -->
                    <div class="bg-white px-4 sm:px-5 py-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                
                        <div>
                            <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-0.5">Start Date</p>
                            <p class="text-sm font-black text-gray-800">
                                {{ userDetails.subsctions.subscriptionStartDate | date:'dd MMM yyyy' }}
                            </p>
                        </div>
                
                        <div>
                            <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-0.5">End Date</p>
                            <p class="text-sm font-black text-gray-800">
                                {{ userDetails.subsctions.subscriptionEndDate | date:'dd MMM yyyy' }}
                            </p>
                        </div>
                
                        <div class="col-span-2">
                            <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-0.5">Last Updated</p>
                            <p class="text-sm font-black text-gray-800">
                                {{ userDetails.subsctions.updatedAt | date:'dd MMM yyyy, hh:mm a' }}
                            </p>
                        </div>
                
                        <div class="col-span-2">
                            <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-0.5">Transaction ID</p>
                            <p class="text-xs font-mono font-bold text-indigo-600 bg-indigo-50 px-3 py-1.5 rounded-lg break-all">
                                {{ userDetails.subsctions.lastTransactionId || '—' }}
                            </p>
                        </div>
                
                    </div>
                
                    <!-- Progress bar: days remaining -->
                    <div class="px-5 pb-4 bg-white" *ngIf="userDetails.subsctions.subscriptionStartDate && userDetails.subsctions.subscriptionEndDate">
                        <div class="flex justify-between text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-1.5">
                            <span>Days Remaining</span>
                            <span>{{ getDaysRemaining(userDetails.subsctions.subscriptionEndDate) }} days left</span>
                        </div>
                        <div class="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
                            <div class="h-full rounded-full transition-all duration-500"
                                [ngClass]="getDaysRemaining(userDetails.subsctions.subscriptionEndDate) > 30
                                    ? 'bg-gradient-to-r from-indigo-500 to-violet-500'
                                    : getDaysRemaining(userDetails.subsctions.subscriptionEndDate) > 10
                                    ? 'bg-gradient-to-r from-yellow-400 to-orange-400'
                                    : 'bg-gradient-to-r from-red-400 to-rose-500'"
                                [style.width]="getSubscriptionProgress(userDetails.subsctions.subscriptionStartDate, userDetails.subsctions.subscriptionEndDate) + '%'">
                            </div>
                        </div>
                    </div>
                
                </div>
                <!-- Opt-Out Status -->
<div class="rounded-2xl overflow-hidden border border-gray-100 shadow-sm mt-10">

    <!-- Header -->
    <div class="px-5 py-3 flex items-center justify-between"
      [ngClass]="userDetails?.isOptOut ? 'bg-gradient-to-r from-red-500 to-rose-600' : 'bg-gray-100'">
  
      <div class="flex items-center gap-2">
        <svg class="w-4 h-4" [ngClass]="userDetails?.isOptOut ? 'text-red-200' : 'text-gray-400'"
          fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M18.364 5.636a9 9 0 11-12.728 12.728A9 9 0 0118.364 5.636M15 9l-6 6m0-6l6 6"/>
        </svg>
        <span class="text-sm font-black"
          [ngClass]="userDetails?.isOptOut ? 'text-white' : 'text-gray-700'">
          Notification Opt-Out
        </span>
      </div>
  
      <!-- Status Pill -->
      <span class="px-2.5 py-0.5 rounded-full text-[10px] font-black uppercase tracking-wider"
        [ngClass]="userDetails?.isOptOut
          ? 'bg-red-400/20 text-red-100 ring-1 ring-red-300/30'
          : 'bg-green-400/20 text-green-700 ring-1 ring-green-300/30'">
        <span class="inline-block w-1.5 h-1.5 rounded-full mr-1 align-middle"
          [ngClass]="userDetails?.isOptOut ? 'bg-red-300' : 'bg-green-400 animate-pulse'">
        </span>
        {{ userDetails?.isOptOut ? 'Opted Out' : 'Subscribed' }}
      </span>
  
    </div>
  
    <!-- Body -->
    <div class="bg-white px-4 sm:px-5 py-4">
  
      <!-- Not opted out -->
      <div *ngIf="!userDetails?.isOptOut" class="text-center py-4">
        <p class="text-sm font-bold text-gray-400">User is currently subscribed</p>
        <p class="text-xs text-gray-300 mt-1">This user will receive property notifications.</p>
      </div>
  
      <!-- Opted out with feedback -->
      <div *ngIf="userDetails?.isOptOut">
  
        <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-3">
          Opt-Out Reasons
        </p>
  
        <!-- Reason Pills -->
        <div class="flex flex-wrap gap-2 mb-5">
  
          <span *ngIf="userDetails?.optOutFeedback?.alreadyPurchased"
            class="px-3 py-1 rounded-full text-xs font-semibold bg-rose-50 text-rose-600 border border-rose-200">
            Already Purchased
          </span>
  
          <span *ngIf="userDetails?.optOutFeedback?.noLongerLooking"
            class="px-3 py-1 rounded-full text-xs font-semibold bg-orange-50 text-orange-600 border border-orange-200">
            No Longer Looking
          </span>
  
          <span *ngIf="userDetails?.optOutFeedback?.notRelevant"
            class="px-3 py-1 rounded-full text-xs font-semibold bg-yellow-50 text-yellow-600 border border-yellow-200">
            Not Relevant
          </span>
  
          <span *ngIf="userDetails?.optOutFeedback?.technicalIssues"
            class="px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-600 border border-blue-200">
            Technical Issues
          </span>
  
          <span *ngIf="userDetails?.optOutFeedback?.switchingService"
            class="px-3 py-1 rounded-full text-xs font-semibold bg-violet-50 text-violet-600 border border-violet-200">
            Switching Service
          </span>
  
          <span *ngIf="userDetails?.optOutFeedback?.manyNotifications"
            class="px-3 py-1 rounded-full text-xs font-semibold bg-pink-50 text-pink-600 border border-pink-200">
            Too Many Notifications
          </span>
  
          <!-- No reason selected -->
          <span *ngIf="!userDetails?.optOutFeedback?.alreadyPurchased &&
                       !userDetails?.optOutFeedback?.noLongerLooking   &&
                       !userDetails?.optOutFeedback?.notRelevant        &&
                       !userDetails?.optOutFeedback?.technicalIssues    &&
                       !userDetails?.optOutFeedback?.switchingService   &&
                       !userDetails?.optOutFeedback?.manyNotifications"
            class="text-xs text-gray-400 italic">
            No reasons selected
          </span>
  
        </div>
  
        <!-- Feedback Text -->
        <div *ngIf="userDetails?.optOutFeedback?.feedback">
          <p class="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-1.5">
            Additional Feedback
          </p>
          <p class="text-sm text-gray-700 bg-gray-50 rounded-xl px-4 py-3 leading-6 border border-gray-100">
            {{ userDetails.optOutFeedback.feedback }}
          </p>
        </div>
  
      </div>
    </div>
  
  </div>
                
                <!-- No subscription -->
                <div *ngIf="!userDetails?.subsctions"
                    class="rounded-2xl border border-dashed border-gray-200 bg-gray-50 px-5 py-6 text-center mt-10">
                    <p class="text-sm font-bold text-gray-400">No active subscription</p>
                    <p class="text-xs text-gray-300 mt-1">This user is on the free Basic plan.</p>
                </div>
            </div>

            <div *ngIf="activeTab === 'Requests'" class="bg-gray-50 rounded-2xl text-gray-700">

                <div class="bg-white rounded-md border border-gray-200 overflow-hidden overflow-x-auto">
                    <table class="w-full text-left border-collapse min-w-[900px]">
                        <thead>
                            <tr class="bg-gray-50/50 border-b border-gray-100">
                                <th class="px-8 py-5 text-xs font-black text-gray-400 uppercase tracking-widest">Property Details</th>
                                <th class="px-8 py-5 text-xs font-black text-gray-400 uppercase tracking-widest">Price & Type</th>
                                <th class="px-8 py-5 text-xs font-black text-gray-400 uppercase tracking-widest">Client Info</th>
                                <!-- <th class="px-8 py-5 text-xs font-black text-gray-400 uppercase tracking-widest text-right">Actions</th> -->
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-50">
                            @for (request of userRequest(); track request._id) {
                            <tr class="group hover:bg-indigo-50/30 transition-all duration-300">

                                <td class="px-8 py-6">
                                    <div class="flex items-center gap-4">
                                        <div class="relative w-20 h-20 rounded-2xl overflow-hidden shadow-sm group-hover:shadow-indigo-100 transition-all">
                                            <img [src]="request.property.imageURL[0]" class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" [alt]="request.property.name">
                                        </div>
                                        <div>
                                            <p class="text-lg font-extrabold text-gray-900 group-hover:text-indigo-600 transition-colors">
                                                {{ request.property.name }}
                                            </p>
                                            <p class="text-sm text-gray-400 flex items-center mt-1">
                                                <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                {{ request.property.location }}
                                            </p>
                                        </div>
                                    </div>
                                </td>

                                <td class="px-8 py-6">
                                    @if (request.property.price[0]; as priceInfo) {
                                    <div class="space-y-1">
                                        <p class="text-xl font-black text-emerald-600">
                                            {{ priceInfo.price | currency:'INR':'symbol':'1.0-0' }}
                                        </p>
                                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-bold bg-indigo-100 text-indigo-700 uppercase tracking-wider">
                                            {{ request.property.propertyType }} • {{ priceInfo.bhkType }}
                                        </span>
                                    </div>
                                    }
                                </td>

                                <td class="px-8 py-6">
                                    <div class="space-y-1.5">
                                        <div class="flex items-center text-sm font-bold text-gray-700">
                                            <svg class="w-4 h-4 mr-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                            {{ request.email }}
                                        </div>
                                        <div class="flex items-center text-xs text-gray-500 font-medium">
                                            <svg class="w-4 h-4 mr-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                            </svg>
                                            {{ request.phone }}
                                        </div>
                                        <div class="flex items-center text-[11px] text-gray-400 italic">
                                            Requested on: {{ request.createdAt | date:'mediumDate' }}
                                        </div>
                                    </div>
                                </td>

                                <!-- <td class="px-8 py-6 text-right">
                                    <button (click)="assignAdvisor(request)" class="px-6 py-2.5 bg-emerald-500 text-white font-black rounded-xl shadow-sm shadow-emerald-100 hover:bg-emerald-600 transition-all active:scale-95 flex items-center gap-2 ml-auto">
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                                        </svg>
                                        Assign Advisor
                                    </button>
                                </td> -->
                            </tr>
                            } @empty {
                            <tr>
                                <td colspan="4" class="px-8 py-12 text-center text-gray-500">
                                    <div class="flex flex-col items-center gap-2">
                                        <p class="text-lg font-bold">No requests found</p>
                                        <p class="text-sm">New property inquiries will appear here.</p>
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

            </div>

            <div *ngIf="activeTab === 'Customer Preferences'" class="text-gray-700">
                <div class="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">

                    <!-- Header -->

                    <div class="flex justify-between items-center mb-6">

                        <div>
                            <h2 class="text-lg font-semibold">Customer Requests</h2>
                            <p class="text-sm text-gray-500">Track all user property preferences</p>
                        </div>

                        <button (click)="openRequestModal()" class="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-sm"> + Add Request </button>

                    </div>


                    <!-- Table -->

                    <div class="overflow-x-auto rounded-xl border border-gray-100">

                        <table class="w-full min-w-[850px] text-sm border rounded-lg overflow-hidden">

                            <thead class="bg-gray-50">

                                <tr>
                                    <!-- <th class="p-3 text-left">Request ID</th> -->
                                    <th class="p-3 text-left">Date</th>
                                    <th class="p-3 text-left">Micro Markets</th>
                                    <th class="p-3 text-left">Budget</th>
                                    <th class="p-3 text-left">Configuration</th>
                                    <th class="p-3 text-left">Community</th>
                                    <th class="p-3 text-left">Project Status</th>
                                    <th class="p-3 text-left">Source</th>
                                    <!-- <th class="p-3 text-left">Actions</th> -->
                                </tr>

                            </thead>


                            <tbody>

                                <tr *ngFor="let req of requests; let i = index" class="border-t hover:bg-gray-50 transition">

                                    <!-- <td class="p-3 font-medium">
                                        {{ req._id }}
                                    </td> -->

                                    <td class="p-3">
                                        {{ req.createdAt | date}}
                                    </td>


                                    <!-- Micro Markets -->

                                    <td class="p-3">

                                        <div class="flex flex-wrap gap-1">

                                            <span *ngFor="let market of req.microMarkets" class="bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded-full">
                                                {{ market.micromarketName }}
                                            </span>

                                        </div>

                                    </td>


                                    <!-- Budget -->

                                    <td class="p-3">
                                        {{ req.budgetRange.min | inrShort}} - {{req.budgetRange.max | inrShort}}
                                    </td>


                                    <!-- Configuration -->

                                    <td class="p-3">
                                        {{ req.configuration || '-' }}
                                    </td>


                                    <!-- Community Preference -->

                                    <td class="p-3">
                                        {{ req.communityPreference || '-' }}
                                    </td>


                                    <!-- Project Status -->

                                    <td class="p-3">

                                        <div class="flex flex-wrap gap-1">

                                            <span *ngFor="let status of req.projectStatus" class="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded-full">
                                                {{ status }}
                                            </span>

                                        </div>

                                    </td>


                                    <!-- Source -->

                                    <td class="p-3">

                                        <span class="text-xs px-2 py-1 rounded bg-gray-100" *ngIf="req.isRequestSource === 'User'">
                                            🌐 Website
                                        </span>

                                        <span class="text-xs px-2 py-1 rounded bg-indigo-100 text-indigo-600" *ngIf="req.isRequestSource === 'Admin'">
                                            👤 Admin
                                        </span>

                                    </td>


                                    <!-- Actions -->

                                    <!-- <td class="p-3 flex gap-3">

                                        <button class="text-indigo-600 text-sm hover:underline">
                                            Edit
                                        </button>

                                        <button
                                            (click)="deleteRequest(i)"
                                            class="text-red-500 text-sm hover:underline"
                                        >
                                            Delete
                                        </button>

                                    </td> -->

                                </tr>

                            </tbody>

                        </table>

                    </div>
                </div>
                <!-- Modal -->


                <div *ngIf="showRequestModal" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

                    <div class="bg-white w-full max-w-[520px] rounded-2xl shadow-xl p-4 sm:p-6 max-h-[90vh] overflow-y-auto">

                        <h3 class="text-lg font-semibold mb-6">
                            Customer Preference Request
                        </h3>

                        <form [formGroup]="requestForm" (ngSubmit)="saveRequest()" class="space-y-6">

                            <!-- MICRO MARKETS -->
                            <div class="relative micro-market-dropdown">
                                <label class="block text-sm font-semibold mb-2">
                                    Preferred Locations
                                    <span class="text-gray-400">(Choose up to 3)</span>
                                </label>

                                <!-- INPUT BOX -->
                                <div 
                                    class="border rounded-lg px-3 py-2 cursor-pointer flex items-center justify-between"
                                    [class.border-red-500]="isInvalid('microMarkets')"
                                    (click)="toggleMicroMarketDropdown(); $event.stopPropagation()"
                                >
                                    <div class="flex flex-wrap gap-2">

                                        <!-- Selected chips -->
                                        <span 
                                            *ngFor="let item of requestForm.value.microMarkets"
                                            class="bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded flex items-center gap-1"
                                        >
                                            {{ item.micromarketName }}
                                            <button 
                                            type="button"
                                            (click)="removeSelection('microMarkets', item); $event.stopPropagation()"
                                            >
                                            ✕
                                            </button>
                                        </span>

                                        <!-- Placeholder -->
                                        <span *ngIf="!requestForm.value.microMarkets?.length" class="text-gray-400">
                                            Select locations you love
                                        </span>

                                    </div>

                                    <!-- RIGHT: Dropdown Icon -->
                                    <div class="ml-2 flex items-center">
                                        <svg 
                                        class="w-4 h-4 text-gray-400 transition-transform duration-200"
                                        [ngClass]="{'rotate-180': microMarketDropdownOpen}"
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24"
                                        >
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                            d="M19 9l-7 7-7-7"/>
                                        </svg>
                                    </div>
                                </div>

                                <!-- DROPDOWN -->
                                <div 
                                    *ngIf="microMarketDropdownOpen"
                                    (click)="$event.stopPropagation()"
                                    class="absolute z-50 bg-white border rounded-lg mt-1 w-full shadow-lg max-h-[300px] overflow-hidden"
                                >

                                    <!-- SEARCH -->
                                    <input 
                                    type="text"
                                    (input)="onMicroMarketSearch($event)"
                                    placeholder="Search location..."
                                    class="w-full border-b px-3 py-2 text-sm outline-none"
                                    />

                                    <!-- OPTIONS -->
                                    <div class="max-h-48 overflow-y-auto">
                                    <label 
                                        *ngFor="let market of filteredCluster"
                                        class="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
                                    >
                                        <input 
                                        type="checkbox"
                                        [checked]="isSelected('microMarkets', market)"
                                        (change)="toggleSelection('microMarkets', market)"
                                        />
                                        <span>{{ market.micromarketName}}</span>
                                    </label>
                                    </div>

                                </div>

                                <!-- ERROR -->
                                <p *ngIf="isInvalid('microMarkets')" class="text-red-500 text-xs mt-1">
                                    Please select at least 1 location (max 3 allowed)
                                </p>
                            </div>

                            <!-- COMMUNITY -->
                            <div>
                                <label class="block text-sm font-semibold mb-2">Community Preference</label>
                                <select formControlName="communityPreference"
                                    [class.border-red-500]="isInvalid('communityPreference')"
                                    class="w-full border rounded-lg px-3 py-2">

                                    <option value="">Select your preferred community type</option>
                                    <option *ngFor="let community of communityOptions">
                                        {{community}}
                                    </option>
                                </select>

                                <p *ngIf="isInvalid('communityPreference')" class="text-red-500 text-xs mt-1">
                                    Please select a community preference
                                </p>
                            </div>

                            <!-- BUDGET -->
                            <div>
                                <label class="block text-sm font-semibold mb-2">Ideal Budget Range</label>
                                <select formControlName="budgetRange"
                                [class.border-red-500]="isInvalid('budgetRange')"
                                class="w-full border rounded-lg px-3 py-2">

                                    <option value="">Select budget range</option>
                                    <option *ngFor="let budget of budgetOptions">
                                        {{budget}}
                                    </option>
                                </select>

                                <p *ngIf="isInvalid('budgetRange')" class="text-red-500 text-xs mt-1">
                                    Please select a budget range
                                </p>
                            </div>

                            <!-- CONFIGURATION -->
                            <div>
                                <label class="block text-sm font-semibold mb-2">Configuration Preference</label>
                                <select formControlName="configuration"
                                [class.border-red-500]="isInvalid('configuration')"
                                class="w-full border rounded-lg px-3 py-2">

                                    <option value="">Select configuration</option>
                                    <option *ngFor="let config of configurationOptions">
                                        {{config}}
                                    </option>
                                </select>

                                <p *ngIf="isInvalid('configuration')" class="text-red-500 text-xs mt-1">
                                    Please select configuration
                                </p>
                            </div>

                            <!-- PROJECT STATUS -->
                            <div class="relative project-status-dropdown">
                                <label class="block text-sm font-semibold mb-2">
                                    Project Status Preference
                                </label>

                                <!-- INPUT BOX -->
                                <div 
                                    class="border rounded-lg px-3 py-2 cursor-pointer flex items-center justify-between"
                                    [class.border-red-500]="isInvalid('projectStatus')"
                                    (click)="toggleProjectStatusDropdown(); $event.stopPropagation()"
                                >
                                    <div class="flex flex-wrap gap-1">

                                    <!-- ✅ Selected values -->
                                    <span 
                                        *ngFor="let item of requestForm.value.projectStatus"
                                        class="bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded flex items-center gap-1"
                                    >
                                        {{ item }}
                                        <button 
                                        type="button"
                                        (click)="removeSelection('projectStatus', item); $event.stopPropagation()"
                                        >
                                        ✕
                                        </button>
                                    </span>

                                    <!-- Placeholder -->
                                    <span *ngIf="!requestForm.value.projectStatus?.length" class="text-gray-400">
                                        Select preferred status
                                    </span>

                                    </div>

                                    <!-- RIGHT: Dropdown Icon -->
                                    <div class="ml-2 flex items-center">
                                        <svg 
                                        class="w-4 h-4 text-gray-400 transition-transform duration-200"
                                        [ngClass]="{'rotate-180': microMarketDropdownOpen}"
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24"
                                        >
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                            d="M19 9l-7 7-7-7"/>
                                        </svg>
                                    </div>
                                </div>

                                <!-- DROPDOWN -->
                                <div 
                                    *ngIf="projectStatusDropdownOpen"
                                    class="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto"
                                >
                                    <div 
                                    *ngFor="let status of projectStatusOptions"
                                    (click)="toggleProjectStatus(status); $event.stopPropagation()"
                                    class="px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center justify-between"
                                    >
                                    <span>{{ status }}</span>

                                    <!-- ✅ Selected tick -->
                                    <span *ngIf="isSelected('projectStatus', status)">✔</span>
                                    </div>
                                </div>

                                <!-- ERROR -->
                                <p *ngIf="isInvalid('projectStatus')" class="text-red-500 text-xs mt-1">
                                    Please select at least one project status
                                </p>
                            </div>

                            <!-- NOTES -->
                            <div>
                                <label class="block text-sm font-semibold mb-2">Customer Preference Note</label>

                                <input 
                                type="text"
                                formControlName="notes"
                                maxlength="200"
                                class="w-full border rounded-lg px-3 py-2"
                                >

                                <p class="text-xs text-gray-400 mt-1">
                                    {{requestForm.get('notes')?.value?.length || 0}} / 200
                                </p>
                            </div>

                            <!-- ACTIONS -->
                            <div class="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-2">

                                <button
                                    type="button"
                                    (click)="closeRequestModal()"
                                    class="w-full sm:w-auto min-h-[48px] px-4 py-3 border border-gray-300 rounded-xl text-gray-700 font-medium hover:bg-gray-50 transition-all">

                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    class="w-full sm:w-auto min-h-[48px] px-5 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-semibold shadow-sm transition-all">

                                    Save Request
                                </button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div *ngIf="activeTab === 'Curate Property Links' && isRoteHasPermissions('canManageUsers')">
                <div class="mb-4 bg-white rounded-2xl flex flex-col sm:flex-row gap-4 items-center transition-all duration-300">
                    <div class="relative flex-grow w-full">
                        <input 
                            type="text" 
                            placeholder="Search properties, locations, or builders..." 
                            [(ngModel)]="searchTerm"
                            (input)="onSearchChange()"
                            class="w-full py-3 pl-12 pr-4 bg-gray-50 border-1 border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:bg-white transition-all duration-200 outline-none text-gray-700"
                        />
                        <svg class="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>
                    <button
                        type="button"
                        *ngIf="isRoteHasPermissions('CanShareProperties')"
                        (click)="(canGenerateLink() && hasAdvisorAssigned()) ? createShareLink() : showGenerateError()"

                        [class.opacity-50]="!canGenerateLink() || !hasAdvisorAssigned()"
                        [class.cursor-not-allowed]="!canGenerateLink() || !hasAdvisorAssigned()"

                        class="w-full sm:w-auto whitespace-nowrap flex items-center justify-center px-6 py-2.5 text-base font-semibold rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:ring-indigo-300 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                        >
                        Generate link
                    </button>
                </div>
                <div class=" mb-4">
                    <small *ngIf="!canGenerateLink() || !hasAdvisorAssigned()" class="text-xs text-red-500">
                        Please assign an advisor and add at least one request or preference to generate a curated link.
                    </small>
                </div>
                <div class="overflow-hidden rounded-2xl bg-white animate-fade-in-slow">
                    <div class="overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white">
                        <table class="min-w-[1100px] divide-y divide-gray-200 mb-8 table">
                            <thead class="bg-indigo-50">
                                <tr class="text-[10px] lg:text-xs font-bold tracking-wider text-gray-500 uppercase">
                                    <th scope="col" class="px-4 lg:px-6 py-4 text-left">
                                        <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 cursor-pointer" />
                                    </th>
                                    <th scope="col" class="px-4 lg:px-6 py-4 text-left">Property / Builder</th>
                                    <th scope="col" class="px-4 lg:px-6 py-4 text-left">Type</th>
                                    <th scope="col" class="px-4 lg:px-6 py-4 text-center">Beds</th>
                                    <th scope="col" class="px-4 lg:px-6 py-4 text-right">Price</th>
                                    <th scope="col" class="px-4 lg:px-6 py-4 text-center">Status</th>
                                    <th scope="col" class="px-4 lg:px-6 py-4 text-center">Actions</th>
                                </tr>
                            </thead>

                            <tbody class="bg-white divide-y divide-gray-200">
                                <ng-container *ngIf="filteredProperties.length > 0 else noPropertiesFound">
                                    <tr *ngFor="let property of filteredProperties ; let i = index" class="hover:bg-indigo-50/50 transition-colors duration-300 group" [class.bg-indigo-50]="isPropertySelected(property._id)">

                                        <td class="px-4 lg:px-6 py-4">
                                            <input type="checkbox" [checked]="isPropertySelected(property._id)" (change)="togglePropertySelection(property._id)" class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 cursor-pointer" />
                                        </td>

                                        <td class="px-4 lg:px-2 py-4">
                                            <div class="flex flex-col">
                                                <p class="text-base font-bold text-gray-900 group-hover:text-indigo-600 transition-colors">{{ property.name }}</p>
                                                <p class="text-xs text-gray-500 flex items-center mt-1">
                                                   <i class="fas fa-map-marker-alt mr-1 text-rose-500"></i> {{ property?.microMarket?.micromarketName || 'N/A' }}, {{ property?.microMarket?.cluster }}
                                                </p>
                                            </div>
                                        </td>

                                        <td class="px-4 lg:px-4 py-4 text-sm font-semibold text-gray-700">
                                            {{ property.propertyType }}
                                        </td>

                                        <td class="px-4 lg:px-4 py-4 text-center text-base font-bold text-indigo-600 text-nowrap">
                                            {{getBHKAndPriceRange(property.price).bhkRange}}
                                        </td>

                                        <td class="px-4 lg:px-6 py-4 text-right">
                                            <p class="text-base font-black text-emerald-700">{{ formatPriceDisplay(property.price) }}</p>
                                        </td>

                                        <td class="px-4 lg:px-6 py-4 text-center">
                                            <span [ngClass]="property.isSoldOut ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'" class="px-3 py-1 text-[10px] font-bold rounded-full uppercase tracking-tighter">
                                                {{ property.isSoldOut ? 'Sold Out' : 'Active' }}
                                            </span>
                                        </td>

                                        <td class="px-4 lg:px-6 py-4">
                                            <div class="flex items-center justify-center space-x-2">
                                                <button (click)="navigateToGallery(property)" class="p-2 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-lg transition-all" title="Upload">
                                                    <i class="fas fa-upload text-sm"></i>
                                                </button>
                                                <button (click)="viewDetails(property)" class="w-full sm:w-auto px-4 py-2.5 bg-indigo-50 text-indigo-700 text-xs font-bold rounded-lg hover:bg-indigo-600 hover:text-white transition-all">
                                                    Details
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>

                                <ng-template #noPropertiesFound>
                                    <tr>
                                        <td colspan="7" class="px-6 py-20 text-center">
                                            <div class="flex flex-col items-center justify-center">
                                                <div class="bg-gray-50 p-4 rounded-full mb-4">
                                                    <i class="fas fa-search-location text-4xl text-gray-300"></i>
                                                </div>
                                                <h3 class="text-lg font-bold text-gray-900">No properties found</h3>
                                                <p class="text-sm text-gray-500 max-w-xs mx-auto">
                                                    We couldn't find any properties matching your current search or filter criteria.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="totalPages > 1" class="flex items-center justify-between mt-6 px-4 py-4 bg-white border border-gray-100 rounded-2xl shadow-sm">

                        <div class="text-sm text-gray-500 font-semibold">
                            Page {{ currentPage }} of {{ totalPages }}
                        </div>

                        <div class="flex items-center gap-2">

                            <!-- Previous -->
                            <button
                                (click)="changePage(currentPage - 1)"
                                [disabled]="currentPage === 1"
                                class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                Previous
                            </button>

                            <!-- First page -->
                            <button
                                *ngIf="currentPage > 3"
                                (click)="changePage(1)"
                                class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                1
                            </button>

                            <span *ngIf="currentPage > 4">...</span>

                            <!-- Visible pages -->
                            <button
                                *ngFor="let page of getVisiblePages()"
                                (click)="changePage(page)"
                                [class.bg-blue-600]="page === currentPage"
                                [class.text-white]="page === currentPage"
                                class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                {{ page }}
                            </button>

                            <span *ngIf="currentPage < totalPages - 3">...</span>

                            <!-- Last page -->
                            <button
                                *ngIf="currentPage < totalPages - 2"
                                (click)="changePage(totalPages)"
                                class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                {{ totalPages }}
                            </button>

                            <!-- Next -->
                            <button
                                (click)="changePage(currentPage + 1)"
                                [disabled]="currentPage === totalPages"
                                class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                Next
                            </button>

                        </div>
                    </div>

                    <ng-template #noPropertiesFound>
                        <div class="text-center w-full p-12 bg-white rounded-xl border-2 border-dashed border-gray-300 shadow-lg">
                            <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2m-7 7h-2"></path>
                            </svg>
                            <h3 class="mt-2 text-sm font-medium text-gray-900">No Properties Found</h3>
                            <p class="mt-1 text-sm text-gray-500">
                                Adjust your search or clear your filters.
                            </p>
                        </div>
                    </ng-template>
                </div>
            </div>

            <div *ngIf="activeTab === 'Shared Links'" class="text-gray-700">
                 <!-- Header -->
                <div class="bg-white border border-gray-200 rounded-2xl shadow-sm p-6 mb-5">
                    <div class="flex items-center justify-between">
                        <div>
                            <h2 class="text-xl font-semibold text-gray-900">Shared Property Links</h2>
                            <p class="text-sm text-gray-500 mt-1">
                                View all curated links shared with this user
                            </p>
                        </div>

                        <div class="px-4 py-2 bg-indigo-50 text-indigo-700 rounded-xl text-sm font-semibold">
                            Total Shared: {{sharedPropertyData.sharedPropertiesCount ?? '0'}}
                        </div>
                    </div>
                </div>

                <!-- Cards -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-5" >

                    <!-- CARD 1 -->
                    @for (group of groupedSharedProperties; track group?.shareToken) {
                        <div class="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden hover:shadow-md transition">
                      
                          <div class="p-5 border-b border-gray-100">
                      
                            <div class="flex justify-between items-start">
                              <div>
                                <p class="text-xs uppercase tracking-widest text-gray-400 font-bold">
                                  Shared On
                                </p>
                                <h4 class="text-sm font-semibold text-gray-900 mt-1">
                                  {{ group.createdAt | date: 'd MMM yyyy, h:mm a' }}
                                </h4>
                              </div>
                      
                              <span
                                class="px-3 py-1 rounded-full text-[11px] font-bold"
                                [ngClass]="isExpired(group.expiresAt)
                                  ? 'bg-red-100 text-red-600'
                                  : 'bg-green-100 text-green-700'">
                                {{ isExpired(group.expiresAt) ? 'Expired' : 'Active' }}
                              </span>
                            </div>
                      
                            <!-- Expiry -->
                            <p class="text-xs text-gray-400 mt-1">
                              Expires: {{ group.expiresAt | date: 'd MMM yyyy' }}
                            </p>
                      
                            <!-- Share Link -->
                            <div class="mt-4 bg-gray-50 border border-gray-100 rounded-xl px-3 py-3 flex gap-2 items-center">
                              <input
                                readonly
                                [value]="group?.link"
                                class="bg-transparent w-full text-sm text-indigo-700 font-medium outline-none break-all">
                      
                              <button
                                (click)="copyLinks(group?.link)"
                                class="px-3 py-1.5 text-xs font-bold rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 transition whitespace-nowrap">
                                Copy
                              </button>
                            </div>
                      
                          </div>
                      
                          <!-- Properties -->
                          <div class="p-5">
                      
                            <div class="flex justify-between items-center mb-4">
                              <h5 class="text-sm font-semibold text-gray-900">
                                Shared Properties
                              </h5>
                              <span class="text-xs font-bold text-gray-400">
                                {{ group.properties.length }} Items
                              </span>
                            </div>
                      
                            <div class="space-y-3">
                      
                              @for (property of group.properties; track property._id) {
                                <div class="flex gap-3 border border-gray-100 rounded-xl p-2">
                      
                                  <!-- No images in API, fallback placeholder -->
                                  <img
                                    [src]="property.images?.[0] ?? 'https://images.unsplash.com/photo-1568605114967-8130f3a36994'"
                                    [alt]="property.name"
                                    class="w-14 h-14 rounded-lg object-cover flex-shrink-0">
                      
                                  <div class="flex-1 min-w-0">
                                    <h6 class="text-sm font-semibold text-gray-900 truncate">
                                      {{ property.name }}
                                    </h6>
                                    <p class="text-xs text-gray-500">
                                      {{ property.propertyType }} • {{ property.cityName }}
                                    </p>
                                    <p class="text-xs text-gray-400">
                                      {{ property.microMarket?.micromarketName }}
                                    </p>
                                    <p class="text-xs font-bold text-emerald-600 mt-1">
                                      {{ getMinPrice(property.price) }}
                                    </p>
                                  </div>
                      
                                </div>
                              }
                      
                            </div>
                      
                          </div>
                      
                        </div>
                      }

                </div>
            </div>
        </div>
    </div>
</main>


<!-- Assign modal -->

<div *ngIf="isAssignAdvisor()" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-md">
    <div class="bg-white w-full max-w-xl rounded-[1.75rem] sm:rounded-[2.5rem] shadow-2xl border border-gray-100 overflow-hidden animate-zoom-in">

        <div class="p-5 sm:p-8 border-b border-gray-50 flex justify-between items-center">
            <div>
                <h2 class="text-2xl font-black text-gray-900 tracking-tight">Assign Advisor</h2>
                <p class="text-gray-500 text-sm">Link an advisor to user</p>
            </div>
            <button (click)="closeModal()" class="p-2 bg-gray-50 rounded-full text-gray-400 hover:text-red-500 transition-colors">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <div class="p-5 sm:p-8 space-y-6">
            <div class="relative group">
                <input type="text" (input)="onSearch($event)"
                       placeholder="Search advisors by name or expertise..." 
                       class="w-full pl-12 pr-4 py-4 bg-gray-50 border-2 border-transparent focus:border-indigo-500 focus:bg-white rounded-2xl outline-none transition-all"
                >
                <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-300 group-focus-within:text-indigo-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>

            <div class="space-y-3 max-h-64 overflow-y-auto pr-2">
              @for (advisor of advisorList(); track advisor._id) {
                <div 
                  (click)="selectAdvisor(advisor._id)"
                  [class]="'flex items-center justify-between p-4 rounded-2xl border-2 transition-all cursor-pointer group ' + 
                           (selectedAdvisorId() === advisor._id ? 'border-indigo-500 bg-indigo-50/30' : 'border-gray-50 hover:border-indigo-200')"
                >
                  <div class="flex items-center gap-4">
                    <img [src]="advisor.advisorImg || 'user.jpeg'" [alt]="advisor.name" class="w-10 h-10 rounded-xl object-cover" />
                    <div>
                      <p class="text-sm font-bold text-gray-900">{{ advisor.name }}</p>
                      <p [class]="'text-[10px] font-bold uppercase tracking-widest ' + 
                                 (selectedAdvisorId() === advisor._id ? 'text-indigo-600' : 'text-gray-400')">
                        {{ advisor.specialization }}
                      </p>
                    </div>
                  </div>
            
                  <div [class]="'w-6 h-6 rounded-full flex items-center justify-center border-2 transition-all ' + 
                               (selectedAdvisorId() === advisor._id ? 'bg-indigo-600 border-indigo-600' : 'border-gray-200 group-hover:border-indigo-400')">
                    
                    @if (selectedAdvisorId() === advisor._id) {
                      <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                      </svg>
                    }
                  </div>
                </div>
              }
            </div>
        </div>

        <div class="p-5 sm:p-8 bg-gray-50 flex gap-4">
            <button (click)="closeModal()" class="flex-1 py-4 font-bold text-gray-500 hover:text-gray-700 transition-colors">Dismiss</button>
            <button (click)="confirmAdvisor()"
            [disabled]="isConfirmDisabled()" class="flex-1 py-4 bg-indigo-600 text-white font-extrabold rounded-2xl shadow-sm shadow-indigo-100 hover:bg-indigo-700 transition-all active:scale-95 disabled:bg-gray-300 disabled:cursor-not-allowed
            enabled:bg-indigo-600 enabled:hover:bg-indigo-700 enabled:shadow-lg enabled:shadow-indigo-200">Confirm Assignment</button>
        </div>
    </div>
</div>


<div *ngIf="isGenerateLink()" class="fixed inset-0 z-[200] flex items-center justify-center bg-gray-900/60 backdrop-blur-md p-4">
    <div class="bg-white w-full max-w-md rounded-[1.75rem] sm:rounded-[2.5rem] shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-300">

        <div class="p-5 sm:p-8 pb-4 flex justify-between items-start">
            <div>
                <h2 class="text-2xl font-black text-gray-900 leading-tight">Share Properties</h2>
                <p class="text-sm font-bold text-indigo-600 uppercase tracking-widest mt-1">
                    {{ selectedPropertyIds.size }} Selected
                    <!-- {{ selectedPropertyIds.size }} / 3 Selected -->
                </p>
            </div>
            <button (click)="closeSharePropertyModal()" class="p-2 bg-gray-50 rounded-full text-gray-400 hover:text-red-500 transition-colors">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="px-8 pb-8">

            <!-- <div *ngIf="selectedPropertyIds.size > 3" class="bg-rose-50 border-2 border-rose-100 rounded-3xl p-6 text-center animate-in shake duration-500">
                <div class="w-16 h-16 bg-rose-100 text-rose-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i class="fas fa-exclamation-triangle text-2xl"></i>
                </div>
                <h3 class="text-rose-900 font-bold text-lg">Limit Exceeded</h3>
                <p class="text-rose-700 text-sm mt-2">
                    You can only share up to **3 properties** at a time. Please remove {{ selectedPropertyIds.size - 3 }} property to continue.
                </p>
            </div> -->

            <div >
                <!-- *ngIf="isSelectionValid" -->
                <p class="text-gray-500 text-sm mb-4">The following properties will be included in your link:</p>

                <div class="space-y-3 mb-6 max-h-[300px] overflow-auto">
                    <div *ngFor="let item of selectedData" class="flex items-center gap-4 bg-gray-50 p-3 rounded-2xl border border-gray-100">
                        <img [src]="item.galleryImage[0]" class="w-12 h-12 rounded-xl object-cover shadow-sm">
                        <div class="flex-1 overflow-hidden">
                            <h4 class="font-bold text-gray-900 truncate">{{ item.name }}</h4>
                            <p class="text-[10px] text-gray-500 font-bold uppercase">{{ item.propertyType }} • {{ item.location }}</p>
                        </div>
                    </div>
                </div>

                <div *ngIf="generatedLink" class="bg-indigo-50 border border-indigo-100 rounded-2xl p-4 mb-6">
                    <label class="text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-2 block">Shared Link</label>
                    <div class="flex items-center gap-2">
                        <input type="text" readonly [value]="generatedLink" class="bg-transparent border-none text-indigo-700 font-bold text-sm w-full focus:ring-0">
                        <button (click)="copyLink()" class="bg-white text-indigo-600 px-4 py-2 rounded-xl text-xs font-black shadow-sm hover:bg-indigo-600 hover:text-white transition-all">
                            {{ isCopied ? 'COPIED!' : 'COPY' }}
                        </button>
                    </div>
                </div>

                <button *ngIf="!generatedLink" (click)="generateShareLink()" [disabled]="isLoading" class="w-full py-4 bg-gray-900 text-white rounded-2xl font-bold shadow-xl hover:bg-indigo-600 transition-all disabled:opacity-50">
                    <span *ngIf="!isLoading">Generate Share Link</span>
                    <i *ngIf="isLoading" class="fas fa-circle-notch fa-spin"></i>
                </button>
            </div>

            <div *ngIf="selectedPropertyIds.size === 0" class="text-center py-10 text-gray-400">
                <i class="far fa-check-square text-4xl mb-4 block opacity-20"></i>
                <p class="font-bold">Select at least one property to share</p>
            </div>

        </div>
    </div>
</div>

<div *ngIf="showDeleteModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm transition-opacity duration-300">

    <div class="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-5 sm:p-8 transform transition-all duration-300 scale-100 animate-in fade-in zoom-in-95">

        <div class="flex items-center justify-center w-16 h-16 mx-auto bg-red-50 rounded-full mb-4">
            <div class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center animate-pulse">
                <svg class="w-7 h-7 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
            </div>
        </div>

        <div class="text-center">
            <h3 class="text-xl font-bold text-gray-900 tracking-tight">Confirm Deletion</h3>
            <p class="mt-3 text-sm leading-relaxed text-gray-500 px-2">
                This is a permanent action. All associated data for this user will be wiped from our systems instantly.
            </p>
        </div>

        <div class="mt-8 flex flex-col sm:flex-row gap-3">
            <button [disabled]="isDeleting" (click)="showDeleteModal = false" class="flex-1 order-2 sm:order-1 px-4 py-2.5 text-sm font-semibold text-gray-600 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all active:scale-95 disabled:opacity-50">
                Go Back
            </button>

            <button (click)="deleteUser()" [disabled]="isDeleting" class="flex-1 order-1 sm:order-2 px-4 py-2.5 text-sm font-semibold text-white bg-red-600 rounded-xl hover:bg-red-700 shadow-lg shadow-red-200 transition-all active:scale-95 flex items-center justify-center gap-2 disabled:opacity-80">

                <svg *ngIf="isDeleting" class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>

                {{ isDeleting ? 'Deleting...' : 'Delete Account' }}
            </button>
        </div>
    </div>
</div>


<!-- Premium Approval / Reject Popup -->

<div
  *ngIf="showApprovalModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">

  <div class="w-full max-w-lg bg-white rounded-3xl shadow-2xl overflow-hidden">

    <!-- Header -->
    <div class="px-6 py-5 border-b border-gray-100 flex items-start justify-between">

      <div class="flex items-center gap-3">

        <div
          class="h-11 w-11 rounded-2xl flex items-center justify-center"
          [ngClass]="approvalState === 'Approved'
            ? 'bg-green-100 text-green-600'
            : 'bg-orange-100 text-orange-600'">

          <svg *ngIf="approvalState === 'Approved'" xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>

          <svg *ngIf="approvalState === 'Rejected'" xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>

        </div>

        <div>
          <h2 class="text-lg font-semibold text-gray-900">
            {{ approvalState }} User
          </h2>
          <p class="text-sm text-gray-500">
            Add a clear reason before continuing
          </p>
        </div>

      </div>

      <button
        (click)="closeApprovalModal()"
        class="h-9 w-9 rounded-xl hover:bg-gray-100 text-gray-500 hover:text-gray-800 transition">
        ✕
      </button>

    </div>

    <!-- Body -->
    <div class="px-6 py-5">

      <label class="block text-sm font-medium text-gray-700 mb-2">
        Reason
      </label>

      <textarea
        [(ngModel)]="approvalReason"
        rows="5"
        maxlength="250"
        placeholder="Type reason here..."
        class="w-full rounded-2xl border border-gray-200 px-4 py-3 text-sm outline-none resize-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100 transition"></textarea>

      <div class="mt-2 flex justify-between text-xs text-gray-400">
        <span>Visible for internal records</span>
        <span  *ngIf="approvalReason">{{ approvalReason.length || 0 }}/250</span>
      </div>

    </div>

    <!-- Footer -->
    <div class="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end gap-3">

      <button
        (click)="closeApprovalModal()"
        class="px-5 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-white transition">
        Cancel
      </button>

      <button
        (click)="submitApprovalUI()"
        [disabled]="!approvalReason.trim()"
        [ngClass]="approvalState === 'Approved'
          ? 'bg-green-600 hover:bg-green-700'
          : 'bg-orange-500 hover:bg-orange-600'"
        class="px-5 py-2.5 rounded-xl text-white font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed">
        Confirm {{ approvalState }}
      </button>

    </div>

  </div>

</div>